import { render } from "./p-color-picker.vue?vue&type=template&id=556ea805&scoped=true"
import script from "./p-color-picker.vue?vue&type=script&lang=js"
export * from "./p-color-picker.vue?vue&type=script&lang=js"

import "./p-color-picker.vue?vue&type=style&index=0&id=556ea805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556ea805"],['__file',"src/components/p-color-picker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "556ea805"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('556ea805', __exports__)) {
    api.reload('556ea805', __exports__)
  }
  
  module.hot.accept("./p-color-picker.vue?vue&type=template&id=556ea805&scoped=true", () => {
    api.rerender('556ea805', render)
  })

}


export default __exports__